let Variant = function () {
  let swatchFix = document.querySelectorAll('.swatch-fix');
  let productFormRows = document.querySelectorAll('.product-form-row');

  swatchFix.forEach((swatchElm, i) => {
    const swatchImgs = swatchElm.querySelectorAll('.swatch-image');

    swatchImgs.forEach(swatchImg => {
      if (swatchImg.getAttribute('src').indexOf('v=') <= -1) {
        swatchImg.style.display = 'none';
      } else {
        swatchImg.style.display = 'block';
      }
    });

  });

  productFormRows.forEach((productFormRow, i) => {
    productFormRow.querySelector('.swatch').setAttribute('id', 'swatch-input-' + i);
    let swatchElms = productFormRow.querySelectorAll('.swatch-element');
    swatchElms.forEach(swatchElm => {
      swatchElm.addEventListener('click', (e) => {
        if (!swatchElm.querySelector('.swatch-input').disabled) {
          let parentElms = e.currentTarget.parentElement.querySelectorAll('.swatch-element');
          parentElms.forEach(parentElm => {
            parentElm.classList.remove('active');
          });
          e.currentTarget.classList.add('active');
        }
      });
    });
  });
}

export default Variant;
